import { render, staticRenderFns } from "./OtherPricesNew.vue?vue&type=template&id=864c2c9c&scoped=true&"
import script from "./OtherPricesNew.vue?vue&type=script&lang=js&"
export * from "./OtherPricesNew.vue?vue&type=script&lang=js&"
import style0 from "./OtherPricesNew.vue?vue&type=style&index=0&id=864c2c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c2c9c",
  null
  
)

export default component.exports